// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"b1255e83","488":"fc7ba0a2"}[chunkId] + ".chunk.js";
};